export default __webpack_public_path__ + "918dabb96dbc78f01518bac195d6ce58.png";